import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadtempComponent } from './loader/loadtemplate.component';
import { UcdComponent } from './loader/ucd-container/ucd.component';
import { GenericComponent } from './loader/generic-container/generic.component';
import { UtilitiesModule } from '../utilities/utilities.module';
import { PipesModule } from "../utilities/pipes/pipes.module";
import { SecondaryValuesComponent } from "../component/secondary-values/secondary-values.component";
import { SpeedBumpComponent } from "../component/speed-bump/speed-bump.component";
import {ErrorMsgComponent} from "../component/error-msg/error-msg.component";
import { AcctMsgComponent } from '../component/acct-msg/acct-msg.component';

@NgModule({
  imports: [CommonModule, UtilitiesModule, PipesModule],
  exports: [
    LoadtempComponent,
    UcdComponent,
    GenericComponent,
    SecondaryValuesComponent,
    SpeedBumpComponent,
    ErrorMsgComponent,
    AcctMsgComponent
  ],
  declarations: [
    LoadtempComponent,
    UcdComponent,
    GenericComponent,
    SecondaryValuesComponent,
    SpeedBumpComponent,
    ErrorMsgComponent,
    AcctMsgComponent
  ],
  entryComponents: [
    UcdComponent,
    GenericComponent,
    SecondaryValuesComponent,
    SpeedBumpComponent,
    ErrorMsgComponent,
    AcctMsgComponent
  ],
  providers: []
})
export class DynamicLoaderModule {}